module.exports = __webpack_public_path__ + "img/colaborator.6b00aa13.webp";